export default __webpack_public_path__ + "static/1-4c1e91eb85c9cbad081afd73c0357a7c.svg";